import { render, staticRenderFns } from "./AddLaborCost.vue?vue&type=template&id=656d6b4b&"
import script from "./AddLaborCost.vue?vue&type=script&lang=js&"
export * from "./AddLaborCost.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports